import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import { postGe } from '../../redux/action';

import './ge.css'; 
import '../common/common.css'; 

import geBanner from '../../images/geBanner.png';
import gearrow1 from '../../images/gearrow_1.png';
import gearrow2 from '../../images/gearrow_2.png';
import gearrow3 from '../../images/gearrow_3.png';

class GeneralInformation extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	res: {}
	    };
    }

	componentDidMount() {
			// this.props.moduleType
			postGe({ "moduleType": this.props.moduleType }).then(res => {
				console.log(res);
				this.setState({ res: res.data })
			}, this);

	}

	
	componentWillMount() {
		
		let token = window.localStorage.getItem("token");
		if (!token) {
			window.location.href = "/login";
		}

	}


	renderSubBodyItem(idx) {
		switch(idx) {
			case 1:
				return (
					<div>
						<div className="subBodyItem">
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section1_title }}></div>
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section1_desc }}></div>
						</div>
						<div className="subBodyItem">
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section2_title }}></div>
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section2_desc }}></div>
						</div>
						<div className="subBodyItem doseTable">
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section3_title }}></div>
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section3_desc }}></div>
						</div>
						<div className="subBodyItem">
							<div className="roundCornerRemark centerAlign">
								<div dangerouslySetInnerHTML={{ __html: this.state.res.remark }}></div>
							</div>
						</div>
					</div>
				);
			case 2:
				return (
					<div>
						<div className="subBodyItem">
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section1_title }}></div>
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section1_desc }}></div>	
						</div>
						<div className="subBodyItem">
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section2_title }}></div>
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section2_desc }}></div>	
						</div>
						
						<div className="subBodyItem">
							<div className="roundCornerRemark centerAlign">
								<div dangerouslySetInnerHTML={{ __html: this.state.res.remark }}></div>
							</div>
						</div>
					</div>
				);
			default:
				return ""
		}
		
	}


	render() {

		return(
			<div className="geContainer">
				<Header urlKey={this.props.urlKey} moduleType={this.props.moduleType} />
				<div className="mainContainer">
					<img className="banner" src={geBanner} />
					{
						(this.props.moduleType == "dosage-and-administration") ? (
							<div className="sectionContainer">
								<div className="headline containerMaxWidth">
									<h2>Dosage and administration</h2>
								</div>
								<div className="bodyContent containerMaxWidth">
									{this.renderSubBodyItem(1)}
								</div>
							</div>
						) : ""
					}
					{
						(this.props.moduleType == "overall-safety-profile") ? (
							<div className="sectionContainer">
								<div className="headline containerMaxWidth">
									<h2>Overall safety profile</h2>
								</div>
								<div className="bodyContent containerMaxWidth">
									{this.renderSubBodyItem(2)}
								</div>
							</div>
						) : ""
					}
					{
						(this.state.res.reference) ? (
							<div className="referenceContainer sectionContainer">
								<div className="headline containerMaxWidth">
									<h2>References</h2>
								</div>
								<div className="bodyContent containerMaxWidth" dangerouslySetInnerHTML={{ __html: this.state.res.reference }} >
								</div>
							</div>
						) : ""
					}
				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(GeneralInformation));